import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 px-4 border-t border-brown/10 bg-cream mt-8" data-id="element-45">
      <div className="max-w-3xl mx-auto text-center" data-id="element-46">
        <p className="font-serif text-xs md:text-sm text-brown/60 leading-relaxed" data-id="element-47">
          Disclaimer: Dies ist ein persönlicher Erfahrungsbericht. Ergebnisse
          können individuell variieren. Bei anhaltenden Beschwerden bitte einen
          Tierarzt aufsuchen.
        </p>
        <p className="font-serif text-xs text-brown/40 mt-4" data-id="element-48">
          &copy; {new Date().getFullYear()} Napftagebuch. Alle Rechte
          vorbehalten.
        </p>
      </div>
    </footer>;
}